import request from '@/utils/request'; // 获取区域管理列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/managerAreaOa/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/managerAreaOa/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/managerAreaOa/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/managerAreaOa/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/managerAreaOa/update',
    method: 'post',
    data: data
  });
} // 根据小区分组id获取小区名称id

export function fetchAreaId(data) {
  return request({
    url: '/pmsservice/api/areaGroupOa/getAreaId',
    method: 'post',
    data: data
  });
}